import { render, staticRenderFns } from "./StartQuickABModal.vue?vue&type=template&id=ec05c956&scoped=true&"
import script from "./StartQuickABModal.vue?vue&type=script&lang=js&"
export * from "./StartQuickABModal.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./StartQuickABModal.vue?vue&type=style&index=0&id=ec05c956&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ec05c956",
  null
  ,true
)

export default component.exports